import React from 'react';
import Carousel from '@components/Carousel';
import { interlaceImg } from '@lib/utils';
import './product-detail-carousel.scss';

@Carousel
class ProductDetailCarousel extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }
    render() {
        const { carouselItem, index } = this.props;
        return (
            <div className='m-product-detail-carousel'>
                <img src={interlaceImg(carouselItem.full.url)} />
            </div>
        )
    }
}

export default ProductDetailCarousel;